import React from "react";

interface TransferHistoryRowProps {
    item: {
        code: string;
        created_at: Date;
        transfer_date: Date;
        sender_name: string;
        from_location_name: string;
        to_location_name: string;
        is_approved: boolean;
        receiver_name?: string | null;
        is_void: boolean;
    };
    onDetailClick: (code: string) => void;
}

const TransferHistoryRow: React.FC<TransferHistoryRowProps> = ({
    item,
    onDetailClick,
}) => {
    return (
        <tr key={item.code}>
            <td className="border border-slate-700 p-2">
                {item.transfer_date ? Intl.DateTimeFormat("id-ID").format(new Date(item.transfer_date)) : "-"}
            </td>
            <td className="border border-slate-700 p-2">{item.code}</td>
            <td className="border border-slate-700 p-2">{item.sender_name}</td>
            <td className="border border-slate-700 p-2">
                {item.from_location_name}
            </td>
            <td className="border border-slate-700 p-2">
                {item.to_location_name}
            </td>
            <td className="border border-slate-700 p-2">
                {item.is_approved ? (
                    <span className="text-green-500 font-semibold">
                        &#10003;
                    </span>
                ) : (
                    <span className="text-red-500 font-semibold">&#10007;</span>
                )}
            </td>
            <td className="border border-slate-700 p-2">
                {item.receiver_name ?? "-"}
            </td>
            <td className="border border-slate-700 p-2">
                {item.is_void ? (
                    <span className="text-green-500 font-semibold">
                        &#10003;
                    </span>
                ) : (
                    <span className="text-red-500 font-semibold">&#10007;</span>
                )}
            </td>
            <td className="border border-slate-700 p-2">
                <button
                    className="bg-indigo-400 text-white px-2 py-1 rounded"
                    onClick={() => onDetailClick(item.code)}
                >
                    Detail
                </button>
            </td>
        </tr>
    );
};

export default TransferHistoryRow;
